/* Lounelle — lightweight size recommender loader */
(function () {
  'use strict';

  var TRIGGER_SELECTOR = '[data-lounelle-size-trigger], [data-lounelle-size-trigger-proxy]';
  var ownScript = document.currentScript;
  var ownSrc = ownScript && ownScript.src ? ownScript.src : '';
  var readyCallbacks = [];

  function resolveCoreSrc() {
    var src = ownSrc;
    if (!src) {
      var loader = document.querySelector('script[src*="lounelle-size-recommender.js"]');
      src = loader && loader.src ? loader.src : '';
    }
    if (!src) return '';

    try {
      var url = new URL(src, window.location.href);
      url.pathname = url.pathname.replace(
        /lounelle-size-recommender\.js$/,
        'lounelle-size-recommender-core.js'
      );
      return url.href;
    } catch (_) {
      return src.replace('lounelle-size-recommender.js', 'lounelle-size-recommender-core.js');
    }
  }

  var coreSrc = resolveCoreSrc();

  function hasRecommender(scope) {
    var root = scope && (scope.matches || scope.querySelector) ? scope : document;
    if (root.matches && root.matches(TRIGGER_SELECTOR)) return true;
    if (root.querySelector && root.querySelector(TRIGGER_SELECTOR)) return true;
    return !!document.querySelector(TRIGGER_SELECTOR);
  }

  function flushReadyCallbacks() {
    var callbacks = readyCallbacks.slice();
    readyCallbacks.length = 0;

    callbacks.forEach(function (callback) {
      try { callback(); } catch (_) {}
    });
  }

  function loadCore(scope, onReady) {
    if (!hasRecommender(scope) || !coreSrc) return;
    if (typeof onReady === 'function') readyCallbacks.push(onReady);

    if (window.__LounelleSizeRecommenderLoaded) {
      flushReadyCallbacks();
      return;
    }
    if (window.__LounelleSizeRecommenderCoreLoading) return;

    window.__LounelleSizeRecommenderCoreLoading = true;

    var script = document.createElement('script');
    script.src = coreSrc;
    script.async = false;
    script.onload = function () {
      window.__LounelleSizeRecommenderCoreLoading = false;
      flushReadyCallbacks();
    };
    script.onerror = function () {
      window.__LounelleSizeRecommenderCoreLoading = false;
      readyCallbacks.length = 0;
    };
    document.head.appendChild(script);
  }

  function triggerFromEvent(event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(TRIGGER_SELECTOR);
  }

  function warmCore(event) {
    var trigger = triggerFromEvent(event);
    if (trigger) loadCore(trigger);
  }

  function handleFirstClick(event) {
    if (window.__LounelleSizeRecommenderLoaded) return;

    var trigger = triggerFromEvent(event);
    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    loadCore(trigger, function () {
      if (trigger.isConnected) trigger.click();
    });
  }

  if (!window.__LounelleSizeRecommenderLoaderReady) {
    window.__LounelleSizeRecommenderLoaderReady = true;

    document.addEventListener('pointerover', warmCore, { capture: true, passive: true });
    document.addEventListener('pointerdown', warmCore, { capture: true, passive: true });
    document.addEventListener('focusin', warmCore, true);
    document.addEventListener('click', handleFirstClick, true);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        loadCore(event.target);
      });

      document.addEventListener('theme:product-info:loaded', function (event) {
        loadCore(event.target);
      });

      loadCore(document);
    }
  }
})();
